const tournamentNameCollator = new Intl.Collator("pt-BR", {
  numeric: true,
  sensitivity: "base",
});

export const sortTournamentsByName = (tournaments) =>
  [...tournaments].sort((a, b) =>
    tournamentNameCollator.compare(a?.nome || "", b?.nome || "")
  );
